import { RootState } from "@redux/store"
import { connect } from "react-redux"

import OutOfStockModal from "../index"

const mapState = (state: RootState) => ({
  email: state.customer.data.email,
})

export default connect(mapState)(OutOfStockModal) as any
